import 'react-day-picker/lib/style.css'
import React from 'react'
import DayPicker from 'react-day-picker'
import { Box, Paper, ClickAwayListener } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { parse } from 'date-fns'

const useStyles = makeStyles(theme => ({
  responsivePaper: {
    '& .DayPicker': {
      maxWidth: '100%',
      overflowX: 'auto',
    },
    '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
      backgroundColor: '#db4c34',
      color: 'white',
    },
    position: 'absolute',
    top: '100%',
    zIndex: 999999,
    width: 300,
    backgroundColor: 'white',
  },
  menuPaper: {
    maxHeight: 600,
  },
}))

const DatePickerPopup = ({
  setIsPickerOpen,
  handleDayClick,
  selectedDate,
  displayedMonth,
  handleMonthChange,
}) => {
  const classes = useStyles()
  const today = new Date()

  return (
    <ClickAwayListener onClickAway={() => setIsPickerOpen(false)}>
      <Paper elevation={3} className={classes.responsivePaper}>
        <Box display="flex" flexDirection="column" alignItems="flex-start" p={2}>
          <DayPicker
            selectedDays={parse(selectedDate, 'MM/DD/YYYY', new Date())}
            onDayClick={handleDayClick}
            disabledDays={{ before: today }}
            fromMonth={new Date(today.getFullYear(), today.getMonth())}
            month={displayedMonth}
            onMonthChange={handleMonthChange}
          />
        </Box>
      </Paper>
    </ClickAwayListener>
  )
}

export default DatePickerPopup
